exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-top {\r\n    height: 80px;\r\n    display: block;\r\n    background: #fafafa;\r\n    margin-top: -30px;\r\n    width: 105%;\r\n    margin-left: -30px;\r\n    border-bottom: 1px solid #e6e8ea;\r\n    padding-top: 25px;\r\n    padding-left: 25px;\r\n}\r\n\r\n.box-change {\r\n    border-right: 1px solid #e6e8ea;\r\n    display: block;\r\n    min-height: 750px;\r\n}\r\n\r\n.title-cp {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n}\r\n\r\n.change {\r\n    padding: 10px;\r\n    margin-right: 0px;\r\n    background: #fbfbfb;\r\n    border: 1px solid #e9eaed;\r\n    color: #333;\r\n    margin-top: 10px;\r\n}\r\n\r\n.box-change .action {\r\n    padding: 10px;\r\n    margin-left: 80%;\r\n}\r\n\r\n.action-state {\r\n    padding: 10px;\r\n}\r\n\r\n.form-state {\r\n    padding: 20px;\r\n}\r\n\r\n.form-control-label {\r\n    padding-bottom: 0px;\r\n    font-weight: 400;\r\n}\r\n.form-state .form-group  {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.action-state span {\r\n    padding : 10px;\r\n    font-weight: 400;\r\n}\r\n\r\n.e-state {\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/ivr/ivr.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/ivr/ivr.css
// module chunks = main